module.exports = __webpack_public_path__ + "static/img/Bryan-Fletcher.8176867.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Bryan-Fletcher.jpg
// module id = +zFY
// module chunks = 0